import React, { Component } from 'react';
import { setCookie } from '../../../../../helpers/cookie';

export default class QrMobileView extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.fetchApiSBP();
    }

    fetchApiSBP() {
        const data = {
            'orderNumber': this.props.orderNumber
        };
        const redirectLink = this.props.redirectLink;
        
        const headers = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

        const route = "/local/php_interface/api/v2/payment/sbp/";

        let apiTimeout = setTimeout(getStatusSBP.bind(this), 30000);
        
        function getStatusSBP() {
            fetch(route, headers)
                .then((response) => response.json())
                .then((json) => {
                    if (json.status === "success" && json.data.order_status !== "expired") {
                        if (json.data.order_status === 'paid') {
                            this.setState({sbpStatus : json.data});

                            setCookie('UNPAID_ORDER', '');
                            setCookie('PAYMENT_LINK', '');
                            setCookie('ORDER_ID', '');
                            setCookie('SBPPAY', '');
                            setCookie('PAYMENT_METHOD', '');
                            setCookie('PUSHKIN_FIO', '');

                            setTimeout(function(){
                                window.location.href = redirectLink;
                            }, 1000);

                            return;
                        }

                        apiTimeout = setTimeout(getStatusSBP.bind(this), 15000);
                    } else if (json.data.order_status === "expired") {
                        setCookie('UNPAID_ORDER', '');
                        setCookie('PAYMENT_LINK', '');
                        setCookie('ORDER_ID', '');
                        setCookie('SBPPAY', '');
                        setCookie('PAYMENT_METHOD', '');
                        setCookie('PUSHKIN_FIO', '');

                        setTimeout(function(){
                            window.location.href = '/';
                        }, 1000);
                    }
                });
        }
    }

    render() {
        const { payInfo, os } = this.props;

        const banks = payInfo.sbp_banks.map((bank) =>
            <a href={os === 'iOS' ? bank.iosUrl : bank.androidUrl }>
                <img src={bank.logo_url} /> <span>{ bank.bank_name }</span>
            </a>
        );

        return (
            <div>
                <p className="sbp-pay_hint">Выберите банк для оплаты</p>
                <p className="sbp-pay_warn"><img src='/local/templates/comfortkino/static/img/sbp-loader.svg' />
                <span>Ждем ответа от СБП<br />Пожалуйста, не закрывайте окно</span></p>
                <div class="sbp-pay_bank-list">
                    { banks }
                </div>
                <style>{`
                    body {
                        overflow: hidden;
                    }
                `}</style>
            </div>
        );
    }
}